import React from 'react'
import PropTypes from 'prop-types'
import { Box, InputBase, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
        fontSize: "16px",
        fontWeight: "600"
    },
}))

function EditableHeadingV2(props) {

    const classes = useStyles();

    return (
        <form className={classes.root} noValidate>
            <InputBase
                className={classes.margin}
                value={props.value}
                onChange={props.onChange}
                inputProps={{ 'aria-label': 'naked' }}
            />
        </form>
    )
}

EditableHeadingV2.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default EditableHeadingV2

